<template>
    <div class="contact-list">
<!--        <div class="contact-list-header" v-if="total !== null">-->
<!--            <div class="contact-count">-->
<!--                <span class="count-text">{{ total || 0 }} kişi bulundu</span>-->
<!--            </div>-->
<!--            <div class="list-actions"></div>-->
<!--        </div>-->
        <div class="contact-list-content">
            <NewSupsisTable
                :columns="tableColumns"
                :data="processedContacts"
                :loading="loading"
                :zebra="false"
                :sortable-columns="true"
                :local-storage-key="tableLocalStorageKey"
                :min-column-width="80"
                :groups="groups"
                :scroll-loading="scrollLoading"
                :external-scroll-top="scrollTop"
                :external-container-height="containerHeight"
                :selectable="selectable"
                :max-select-count="maxSelectCount"
                :filterable="filterable"
                :filters="filters"
                :sort-field="sortField"
                :sort-direction="sortDirection"
                @row-click="onRowClick"
                @row-dblclick="onRowDblClick"
                @scroll-load="onScrollLoad"
                @selection-change="onSelectionChange"
                @filter-toggle="onFilterToggle"
                @sort-change="onSortChange"
            >
                <template #cell-avatar="slotProps">
                    <ContactAvatar :contact="slotProps.row" size="smallest" />
                </template>

                <template #cell-name="slotProps">
                    <div class="contact-name">
                        <span class="name-text">{{ (slotProps.row && slotProps.row.fullname) || "-" }}</span>
                    </div>
                </template>

                <template #cell-platform="slotProps">
                    <div class="platform-badge" :class="'platform-' + (slotProps.row && slotProps.row.platform)">
                        <SupsisIcon
                            v-if="(slotProps.row && slotProps.row.platform) === 'supsis'"
                            class="platform-icon supsis-icon"
                        />
                        <i v-else class="material-icons platform-icon">{{
                            getPlatformIcon(slotProps.row && slotProps.row.platform)
                        }}</i>
                        <span class="platform-text">{{ slotProps.row && slotProps.row.platform }}</span>
                    </div>
                </template>

                <template #cell-email="slotProps">
                    <span class="email-text">{{ (slotProps.row && slotProps.row.email) || "-" }}</span>
                </template>

                <template #cell-phone="slotProps">
                    <span class="phone-text">{{ (slotProps.row && slotProps.row.phone) || "-" }}</span>
                </template>

                <template #cell-tags="slotProps">
                    <div class="tags-container">
                        <span
                            v-for="tag in getContactTags(slotProps.row)"
                            :key="tag._id"
                            class="tag-chip"
                            :style="getTagStyle(tag)"
                        >
                            {{ tag.name }}
                        </span>
                        <span v-if="!getContactTags(slotProps.row).length" class="no-tags">-</span>
                    </div>
                </template>

                <template #cell-channel="slotProps">
                    <span class="channel-text">{{ getChannelName(slotProps.row) }}</span>
                </template>

                <template #cell-status="slotProps">
                    <div
                        class="status-badge"
                        :class="
                            getStatusClass(
                                slotProps.row && slotProps.row.lastConversation && slotProps.row.lastConversation.status
                            )
                        "
                    >
                        {{
                            getStatusText(
                                slotProps.row && slotProps.row.lastConversation && slotProps.row.lastConversation.status
                            )
                        }}
                    </div>
                </template>

                <template #cell-owner="slotProps">
                    <span class="owner-text">{{ getOwnerName(slotProps.row) }}</span>
                </template>

                <template #cell-vip="slotProps">
                    <div class="vip-indicator" :class="{ 'vip-active': slotProps.row && slotProps.row.vipCustomer }">
                        <i class="material-icons">{{
                            slotProps.row && slotProps.row.vipCustomer ? "star" : "star_border"
                        }}</i>
                    </div>
                </template>

                <template #cell-connectionTime="slotProps">
                    <a-tooltip :title="formatFullDateTime(slotProps.row.connectionTime)">
                        <span class="connection-time">{{ formatConnectionTime(slotProps.row) }}</span>
                    </a-tooltip>
                </template>

                <template #cell-lastActionTime="slotProps">
                    <a-tooltip :title="formatFullDateTime(slotProps.row.lastActionTime)">
                        <span class="last-action-time">{{ formatLastActionTime(slotProps.row) }}</span>
                    </a-tooltip>
                </template>

                <template #cell-answerStatus="slotProps">
                    <div class="answer-status" :class="'answer-' + (slotProps.row && slotProps.row.answerStatus)">
                        {{ getAnswerStatusText(slotProps.row && slotProps.row.answerStatus) }}
                    </div>
                </template>

                <template #cell-unread="slotProps">
                    <div class="unread-status" :class="{ 'unread-active': slotProps.row && slotProps.row.unread }">
                        <i class="material-icons">{{
                            slotProps.row && slotProps.row.unread ? "mark_email_unread" : "mark_email_read"
                        }}</i>
                    </div>
                </template>

                <template #cell-relatedDepartments="slotProps">
                    <div class="departments-container">
                        <span class="departments-text">{{ getRelatedDepartments(slotProps.row) }}</span>
                    </div>
                </template>

                <template #cell-os="slotProps">
                    <span class="os-text">{{ (slotProps.row && slotProps.row.os) || "-" }}</span>
                </template>

                <template #cell-browser="slotProps">
                    <span class="browser-text">{{ (slotProps.row && slotProps.row.browser) || "-" }}</span>
                </template>

                <template #cell-countryCity="slotProps">
                    <span class="country-city-text">{{ getCountryCity(slotProps.row) }}</span>
                </template>

                <template #cell-ipAddress="slotProps">
                    <span class="ip-address-text">{{ (slotProps.row && slotProps.row.ipAddress) || "-" }}</span>
                </template>

                <template #cell-visitingPage="slotProps">
                    <span class="visiting-page-text" :title="(slotProps.row && slotProps.row.visitingPage) || '-'">
                        {{ (slotProps.row && slotProps.row.visitingPage) || "-" }}
                    </span>
                </template>

                <template #cell-lastConversationCreatedDate="slotProps">
                    <a-tooltip
                        :title="
                            formatFullDateTime(
                                slotProps.row.lastConversation && slotProps.row.lastConversation.createdDate
                            )
                        "
                    >
                        <span class="last-conversation-date">{{ getLastConversationDate(slotProps.row) }}</span>
                    </a-tooltip>
                </template>

                <template #cell-createdAt="slotProps">
                    <a-tooltip :title="formatFullDateTime(slotProps.row.createdAt)">
                        <span class="created-at-text">{{ formatCreatedAt(slotProps.row) }}</span>
                    </a-tooltip>
                </template>

                <template #cell-updatedAt="slotProps">
                    <a-tooltip :title="formatFullDateTime(slotProps.row.updatedAt)">
                        <span class="updated-at-text">{{ formatUpdatedAt(slotProps.row) }}</span>
                    </a-tooltip>
                </template>

                <template #cell-blockedSnapshot="slotProps">
                    <div
                        class="blocked-status"
                        :class="{ 'blocked-active': slotProps.row && slotProps.row.blockedSnapshot }"
                    >
                        <i class="material-icons">{{
                            slotProps.row && slotProps.row.blockedSnapshot ? "block" : "check_circle"
                        }}</i>
                        <span>{{ getBlockedStatus(slotProps.row) }}</span>
                    </div>
                </template>

                <template #cell-lastConversationUsers="slotProps">
                    <div class="conversation-users-container">
                        <div v-for="userId in getConversationUserIds(slotProps.row)" :key="userId" class="user-item">
                            <AgentAvatar
                                :userID="userId"
                                :size="24"
                                :fontSize="10"
                                :isNamed="false"
                                :singleChar="true"
                                class="user-mini-avatar"
                            />
                            <span class="user-name">{{ getUserName(userId) }}</span>
                        </div>
                        <span v-if="!getConversationUserIds(slotProps.row).length" class="no-users">-</span>
                    </div>
                </template>

                <template #cell-preferredLang="slotProps">
                    <span class="preferred-lang-text">{{ getPreferredLangLabel(slotProps.row) }}</span>
                </template>

                <template #cell-zohoContactId="slotProps">
                    <span class="zoho-contact-id-text">{{
                        (slotProps.row && slotProps.row.zohoInfo && slotProps.row.zohoInfo.contactId) || "-"
                    }}</span>
                </template>

                <template #cell-zohoLeadId="slotProps">
                    <span class="zoho-lead-id-text">{{
                        (slotProps.row && slotProps.row.zohoInfo && slotProps.row.zohoInfo.leadId) || "-"
                    }}</span>
                </template>

                <template #cell-broadcastStatus="slotProps">
                    <div class="broadcast-status" :class="'broadcast-' + getBroadcastStatus(slotProps.row)">
                        {{ getBroadcastStatusText(slotProps.row) }}
                    </div>
                </template>

                <template #cell-broadcastAnswered="slotProps">
                    <div class="broadcast-answered" :class="{ 'answered-active': getBroadcastAnswered(slotProps.row) }">
                        <i class="material-icons">{{
                            getBroadcastAnswered(slotProps.row) ? "reply" : "reply_all"
                        }}</i>
                        <span>{{ getBroadcastAnsweredText(slotProps.row) }}</span>
                    </div>
                </template>

                <template
                    v-for="property in contactProperties"
                    :slot="`cell-contactProperty_${property._id}`"
                    slot-scope="slotProps"
                >
                    <div
                        v-if="property.type === 'json' && getContactPropertyRawValue(slotProps.row, property._id)"
                        class="json-badge"
                        @click.stop="openJsonModal(slotProps.row, property._id)"
                    >
                        <i class="material-icons json-icon">code</i>
                        <span class="json-text">JSON</span>
                    </div>
                    <span v-else>
                        {{ getContactPropertyValue(slotProps.row, property._id) }}
                    </span>
                </template>

                <template #empty>
                    <div class="empty-state">
                        <i class="material-icons empty-icon">people_outline</i>
                        <span class="empty-text">{{ $t('chat.contactList.noContactsFound') }}</span>
                    </div>
                </template>
            </NewSupsisTable>
        </div>

        <Modal2
            v-if="jsonModal.visible"
            :title="jsonModal.title"
            @cancel="closeJsonModal"
            :showFooter="false"
            design="v3"
        >
            <prism-editor
                :value="jsonModal.content"
                class="my-editor"
                :line-numbers="false"
                :highlight="highlighter"
                readonly
            />
            <div style="display: flex; justify-content: space-between; margin-top: 16px">
                <SupsisButton @click="copyJsonContent">{{ $t("message.copy") }}</SupsisButton>
                <SupsisButton @click="closeJsonModal">{{ $t("message.cancel") }}</SupsisButton>
            </div>
        </Modal2>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import NewSupsisTable from "../../common/NewSupsisTable.vue";
import AgentAvatar from "../../common/AgentAvatar.vue";
import ContactAvatar from "./ContactAvatar.vue";
import Modal2 from "../../common/Modal2.vue";
import SupsisButton from "../../../views/Pages/Settings/components/SupsisButton.vue";
import SupsisIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/SupsisIcon.vue";
import { PrismEditor } from "vue-prism-editor";
import { copyText2Clipboard } from "../../../utils/utils";

export default {
    name: "ContactList",
    components: {
        NewSupsisTable,
        AgentAvatar,
        ContactAvatar,
        Modal2,
        SupsisButton,
        SupsisIcon,
        PrismEditor,
    },
    props: {
        tableLocalStorageKey: {
            type: String,
            default: "contactListColumnOrder",
        },
        contacts: {
            type: Array,
            default: () => [],
        },
        total: {
            type: Number,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        groups: {
            type: Array,
            default: () => [],
        },
        scrollLoading: {
            type: Boolean,
            default: false,
        },
        scrollTop: {
            type: Number,
            default: 0,
        },
        containerHeight: {
            type: Number,
            default: 0,
        },
        selectable: {
            type: Boolean,
            default: false,
        },
        maxSelectCount: {
            type: Number,
            default: 500,
        },
        filterable: {
            type: Boolean,
            default: false,
        },
        filters: {
            type: Array,
            default: () => [],
        },
        sortField: {
            type: String,
            default: null,
        },
        sortDirection: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            jsonModal: {
                visible: false,
                title: "",
                content: "",
                propertyId: null,
            },
        };
    },
    mounted() {},
    computed: {
        ...mapState({
            tags: (state) => state.tag.tags.data || [],
            channels: (state) => state.channel.channels || [],
            users: (state) => state.user.users.data || [],
            subjects: (state) => state.subject.subjects.data || [],
            contactProperties: (state) => state.contactProperty.data,
            languages: (state) => state.language.languages || [],
            zohoChannelExists: (state) => !!state.channel.channels.find((x) => x.type === "zoho"),
        }),
        tableColumns() {
            const baseColumns = [
                {
                    key: "avatar",
                    title: "",
                    selectable: false,
                    resizable: false,
                    visible: true,
                    width: 50,
                    minWidth: 50,
                    fixed: true,
                    fixedPosition: "left",
                    icon: "account_circle",
                    filterable: false,
                },
                {
                    key: "name",
                    title: this.$t('chat.contactList.fullName'),
                    selectable: false,
                    visible: true,
                    fixed: true,
                    fixedPosition: "left",
                    width: 200,
                    icon: "person",
                    filterable: true,
                    multiple: false,
                    sortable: true
                },
                { key: "platform", title: this.$t('chat.contactList.platform'), visible: true, width: 120, icon: "label", filterable: true, multiple: true, sortable: true },
                { key: "email", title: this.$t('chat.contactList.email'), visible: true, width: 180, icon: "email", filterable: true, multiple: false, sortable: true },
                { key: "phone", title: this.$t('chat.contactList.phone'), visible: true, width: 140, icon: "phone", filterable: true, multiple: false, sortable: true },
                { key: "tags", title: this.$t('chat.contactList.tags'), visible: true, width: 180, icon: "label", filterable: true, sortable: true },
                { key: "status", title: this.$t('chat.contactList.status'), visible: true, width: 110, icon: "label", filterable: false, sortable: true },
                { key: "lastActionTime", title: this.$t('chat.contactList.lastActivity'), visible: true, width: 160, icon: "schedule", filterable: true, multiple: false, sortable: true },
                { key: "answerStatus", title: this.$t('chat.contactList.answerStatus'), visible: true, width: 120, icon: "question_answer", filterable: true, multiple: false, sortable: true },
                { key: "channel", title: this.$t('chat.contactList.channel'), visible: true, width: 140, icon: "label", filterable: true, multiple: true, sortable: true },
                { key: "owner", title: this.$t('chat.contactList.owner'), visible: true, width: 140, icon: "label", filterable: true, multiple: true, emptyValue: "unowned", sortable: true },
                { key: "vip", title: this.$t('chat.contactList.vip'), visible: false, width: 80, icon: "label", filterable: true, multiple: false, sortable: true },
                { key: "connectionTime", title: this.$t('chat.contactList.connectionTime'), visible: false, width: 160, icon: "schedule", filterable: true, multiple: false, sortable: true },
                { key: "unread", title: this.$t('chat.contactList.unread'), visible: false, width: 100, icon: "mark_email_unread", filterable: true, multiple: false, sortable: true },
                { key: "relatedDepartments", title: this.$t('chat.contactList.departments'), visible: false, width: 180, icon: "group", filterable: true, multiple: true, sortable: true },
                { key: "os", title: this.$t('chat.contactList.operatingSystem'), visible: false, width: 140, icon: "computer", filterable: true, multiple: false, sortable: true },
                { key: "browser", title: this.$t('chat.contactList.browser'), visible: false, width: 140, icon: "web", filterable: true, multiple: false, sortable: true },
                { key: "countryCity", title: this.$t('chat.contactList.countryCity'), visible: false, width: 160, icon: "location_on", filterable: false },
                { key: "ipAddress", title: this.$t('chat.contactList.ipAddress'), visible: false, width: 140, icon: "router", filterable: true, multiple: false, sortable: true },
                { key: "visitingPage", title: this.$t('chat.contactList.visitingPage'), visible: false, width: 200, icon: "web", filterable: true, multiple: false, sortable: true },
                {
                    key: "lastConversationCreatedDate",
                    title: this.$t('chat.contactList.lastConversationDate'),
                    visible: false,
                    width: 160,
                    icon: "schedule",
                    filterable: false
                },
                { key: "whatsappId", title: "Whatsapp ID", visible: false, width: 160, icon: "label", filterable: true, multiple: false, sortable: false },
                { key: "blockedSnapshot", title: this.$t('chat.contactList.blockedStatus'), visible: false, width: 120, icon: "block", filterable: true, multiple: false, sortable: true },
                {
                    key: "lastConversationUsers",
                    title: this.$t('chat.contactList.lastConversationParticipants'),
                    visible: false,
                    width: 180,
                    icon: "group",
                    filterable: true,
                    multiple: true,
                    emptyValue: "none",
                    sortable: true
                },
                {
                    key: "preferredLang",
                    title: this.$t('chat.contactList.preferredLanguage'),
                    visible: false,
                    width: 140,
                    icon: "language",
                    filterable: false,
                    sortable: true
                },
                {
                    key: "createdAt",
                    title: this.$t('chat.contactList.createdAt'),
                    visible: false,
                    width: 160,
                    icon: "access_time",
                    filterable: true,
                    multiple: false,
                    sortable: true
                },
                {
                    key: "updatedAt",
                    title: this.$t('chat.contactList.updatedAt'),
                    visible: true,
                    width: 160,
                    icon: "update",
                    filterable: true,
                    multiple: false,
                    sortable: true
                },
                {
                    group: "WhatsApp Broadcast",
                    key: "broadcastStatus",
                    title: this.$t('chat.contactList.broadcastStatus'),
                    visible: false,
                    width: 140,
                    icon: "info",
                    filterable: false,
                    sortable: true
                },
                {
                    group: "WhatsApp Broadcast",
                    key: "broadcastAnswered",
                    title: this.$t('chat.contactList.broadcastAnswer'),
                    visible: false,
                    width: 120,
                    icon: "reply",
                    filterable: false,
                    sortable: true
                },
                this.zohoChannelExists && {
                    group: "Zoho",
                    key: "zohoContactId",
                    title: this.$t('chat.contactList.zohoContactId'),
                    visible: false,
                    width: 160,
                    icon: "label",
                    filterable: true,
                    sortable: true
                },
                this.zohoChannelExists && {
                    group: "Zoho",
                    key: "zohoLeadId",
                    title: this.$t('chat.contactList.zohoLeadId'),
                    visible: false,
                    width: 160,
                    icon: "label",
                    filterable: true,
                    sortable: true
                },
            ].filter(Boolean);

            return [...baseColumns, ...this.contactPropertyColumns];
        },
        contactPropertyColumns() {
            return this.contactProperties.map((property) => ({
                key: `contactProperty_${property._id}`,
                title: property.label || property.name,
                visible: false,
                width: property.type === "json" ? 120 : 150,
                icon: "settings",
                group: this.$t('chat.contactList.profileFields'),
                propertyId: property._id,
                propertyType: property.type,
                filterable: true,
                multiple: false
            }));
        },
        processedContacts() {
            if (!this.contacts || !Array.isArray(this.contacts)) {
                return [];
            }

            var processed = this.contacts.map((contact) => {
                const processed = { ...contact };

                // name field'ını fullname'den al
                processed.name = contact.fullname;

                // Contact properties'leri flattened hale getir ve type'a göre formatla
                if (contact.contactPropertiesSnapshot && typeof contact.contactPropertiesSnapshot === "object") {
                    Object.entries(contact.contactPropertiesSnapshot).forEach(([propertyId, value]) => {
                        const property = this.contactProperties.find((cp) => cp._id === propertyId);
                        let displayValue = value || "-";

                        if (property && value) {
                            switch (property.type) {
                                case "date":
                                    try {
                                        displayValue = this.$moment(value).format("DD/MM/YYYY");
                                    } catch (e) {
                                        displayValue = value;
                                    }
                                    break;
                                case "json":
                                    displayValue = "JSON"; // JSON badge
                                    break;
                                case "email":
                                case "phone":
                                case "url":
                                case "text":
                                case "number":
                                case "dropdown":
                                default:
                                    displayValue = value;
                                    break;
                            }
                        }

                        processed[`contactProperty_${propertyId}`] = displayValue;
                    });
                }

                return processed;
            });

            return processed;
        },
        // Her column için değeri nasıl göstereceğimizi belirten fonksiyon
        getCellValue(contact, columnKey) {
            if (!columnKey || typeof columnKey !== "string") return "-";

            switch (columnKey) {
                case "name":
                    return contact.fullname || "-";
                case "platform":
                    return contact.platform || "-";
                case "email":
                    return contact.email || "-";
                case "phone":
                    return contact.phone || contact.whatsappNumber || "-";
                case "tags":
                    return (
                        this.getContactTags(contact)
                            .map((tag) => tag.name)
                            .join(", ") || "-"
                    );
                case "channel":
                    return this.getChannelName(contact);
                case "status":
                    return this.getStatusText(contact.lastConversationStatus);
                case "owner":
                    return this.getOwnerName(contact);
                case "vip":
                    return this.getVipStatus(contact);
                case "connectionTime":
                    return this.formatConnectionTime(contact);
                case "lastActionTime":
                    return this.formatLastActionTime(contact);
                case "answerStatus":
                    return this.getAnswerStatusText(contact.answerStatus);
                case "unread":
                    return this.getUnreadStatus(contact);
                case "relatedDepartments":
                    return this.getRelatedDepartments(contact);
                case "os":
                    return contact.os || "-";
                case "browser":
                    return contact.browser || "-";
                case "countryCity":
                    return this.getCountryCity(contact);
                case "ipAddress":
                    return contact.ipAddress || "-";
                case "visitingPage":
                    return contact.visitingPage || "-";
                case "lastConversationCreatedDate":
                    return this.getLastConversationDate(contact);
                case "blockedSnapshot":
                    return this.getBlockedStatus(contact);
                case "lastConversationUsers":
                    return this.getLastConversationUsers(contact);
                case "preferredLang":
                    return this.getPreferredLangLabel(contact);
                case "createdAt":
                    return this.formatCreatedAt(contact);
                case "updatedAt":
                    return this.formatUpdatedAt(contact);
                case "broadcastStatus":
                    return this.getBroadcastStatusText(contact);
                case "broadcastAnswered":
                    return this.getBroadcastAnsweredText(contact);
                default:
                    // Dinamik contact properties kontrolü
                    if (columnKey && typeof columnKey === "string" && columnKey.startsWith("contactProperty_")) {
                        const propertyId = columnKey.replace("contactProperty_", "");
                        return this.getContactPropertyValue(contact, propertyId);
                    }
                    return "-";
            }
        },
    },
    methods: {
        ...mapActions({
            getContactById: "contact/getContactById",
            addNewWindow: "app/addNewWindow",
            fetchContact: "contact/fetchContact",
        }),
        onScrollLoad(payload) {
            this.$emit('scroll-load', payload);
        },
        onSelectionChange(payload) {
            this.$emit('selection-change', payload);
        },
        onFilterToggle(payload) {
            // Field adını API formatına dönüştür
            let apiField = payload.field;
            let apiValue = payload.value;
            let transformedPayload = { ...payload };

            // Kolon tanımından multiple bilgisini al
            const column = this.tableColumns.find(col => col.key === apiField);
            const isMultiple = column && column.multiple === true;

            // Contact Property kolonları için
            if (apiField.startsWith('contactProperty_')) {
                const propertyId = apiField.replace('contactProperty_', '');
                apiField = `contactProperties.${propertyId}`;
                transformedPayload.field = apiField;
            }
            // Zoho kolonları için
            else if (apiField === 'zohoContactId' || apiField === 'zohoLeadId') {
                const zohoType = apiField === 'zohoContactId' ? 'contact' : 'lead';
                apiField = 'zohoInfo';
                transformedPayload.field = apiField;
                transformedPayload.value = {
                    selectValue: zohoType,
                    inputValue: apiValue
                };
            }

            // ✅ SOLID Approach: Multiple kontrolünü üst component'e bırak
            // Sadece field'ın multiple olup olmadığını bildir
            transformedPayload.isMultiple = isMultiple;

            // Tarih alanları için operator ayarla ve değeri dönüştür
            const dateFields = ['lastActionTime', 'connectionTime', 'createdAt', 'updatedAt'];
            if (dateFields.includes(apiField)) {
                transformedPayload.operator = 'greater_than_or_equal';
                // Tarih değerini ISO string'e çevir
                if (apiValue) {
                    transformedPayload.value = this.$moment(apiValue).toISOString();
                }
            } else {
                transformedPayload.operator = 'equals';
            }

            this.$emit('filter-toggle', transformedPayload);
        },
        onSortChange(sortPayload) {
            // NewSupsisTable'dan gelen sort event'ini parent'a ilet
            // sortPayload: { key: 'columnKey', order: 'asc' | 'desc' | null }
            this.$emit('sort-change', sortPayload);
        },
        onRowClick(row) {
            if (!row) return;
            this.openContact(row._id);
        },
        onRowDblClick(row) {
            if (!row) return;
            this.openContact(row._id);
        },
        getPlatformIcon(platform) {
            const icons = {
                web: "web",
                whatsapp: "chat",
                telegram: "send",
                instagram: "photo_camera",
                facebook: "facebook",
                email: "email",
            };
            return icons[platform] || "help_outline";
        },
        getContactTags(contact) {
            if (!contact.tags || !Array.isArray(contact.tags)) return [];
            return contact.tags
                .map((tagId) => this.tags.find((tag) => tag._id === tagId))
                .filter(Boolean)
                .slice(0, 3); // Sadece ilk 3 etiketi göster
        },
        getChannelName(contact) {
            if (!contact.channel) return "-";
            const channel = this.channels.find((ch) => ch._id === contact.channel);
            return channel?.name || "-";
        },
        getStatusText(status) {
            // Backend'den gelen status değerleri: "active", "new", "chatbot" = Açık, "destroyed" = Kapalı
            if (status === "destroyed") {
                return this.$t('chat.contactList.closed');
            } else if (status === "active" || status === "new" || status === "chatbot") {
                return this.$t('chat.contactList.open');
            }
            return this.$t('chat.contactList.unknownStatus');
        },
        getStatusClass(status) {
            // CSS class'ları için mapping
            if (status === "destroyed") {
                return "status-closed";
            } else if (status === "active" || status === "new" || status === "chatbot") {
                return "status-open";
            }
            return "status-unknown";
        },
        getOwnerName(contact) {
            if (!contact.owner) return "-";
            const user = this.users.find((u) => u._id === contact.owner);
            return user?.fullname || user?.name || "-";
        },
        getRelatedDepartments(contact) {
            if (!contact.relatedDepartments || !Array.isArray(contact.relatedDepartments)) return "-";
            const departmentNames = contact.relatedDepartments
                .map((deptId) => {
                    const dept = this.subjects.find((s) => s._id === deptId);
                    return dept?.languageContent?.[this.$i18n.locale]?.name || dept?.name;
                })
                .filter(Boolean);
            return departmentNames.join(", ") || "-";
        },
        getCountryCity(contact) {
            const country = contact.country || "";
            const city = contact.city || "";
            if (!country && !city) return "-";
            if (country && city) return `${country} - ${city}`;
            return country || city;
        },
        getLastConversationDate(contact) {
            if (!contact.lastConversation?.createdDate) return "-";

            const createdDate = new Date(contact.lastConversation.createdDate);
            const now = new Date();
            const diffTime = Math.abs(now - createdDate);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            // Eğer konuşma kapalıysa today/yesterday formatı
            if (contact.lastConversationStatus === "destroyed") {
                if (diffDays === 1) return this.$t('chat.contactList.today');
                if (diffDays === 2) return this.$t('chat.contactList.yesterday');
                return this.$moment(createdDate).format("DD/MM/YYYY");
            }

            // Aktif konuşma ise zaman formatı
            return this.$moment(createdDate).format("HH:mm");
        },
        getContactPropertyValue(contact, propertyId) {
            if (!contact.contactPropertiesSnapshot || !propertyId) return "-";
            const value = contact.contactPropertiesSnapshot[propertyId];
            if (!value) return "-";

            // Property type'ını bul
            const property = this.contactProperties.find((cp) => cp._id === propertyId);
            if (!property) return value;

            // Type'a göre formatlama
            switch (property.type) {
                case "date":
                    try {
                        return this.$moment(value).format("DD/MM/YYYY");
                    } catch (e) {
                        return value;
                    }
                case "json":
                    return value; // JSON raw değeri döndür, template'te button gösterilecek
                case "email":
                case "phone":
                case "url":
                case "text":
                case "number":
                case "dropdown":
                default:
                    return value;
            }
        },
        getLastConversationUsers(contact) {
            if (!contact.lastConversationUsers || !Array.isArray(contact.lastConversationUsers)) return "-";
            const userNames = contact.lastConversationUsers
                .map((userId) => {
                    const user = this.users.find((u) => u._id === userId);
                    return user?.fullname || user?.name;
                })
                .filter(Boolean);
            return userNames.join(", ") || "-";
        },
        getConversationUserIds(contact) {
            if (!contact.lastConversationUsers || !Array.isArray(contact.lastConversationUsers)) return [];
            return (contact.lastConversationUsers || []).slice(0, 3); // Maximum 3 avatar göster
        },
        getUserName(userId) {
            const user = this.users.find((u) => u._id === userId);
            return user?.fullname || user?.name || this.$t('chat.contactList.unknown');
        },
        formatConnectionTime(contact) {
            if (!contact.connectionTime) return "-";
            return this.$moment(contact.connectionTime).format("DD/MM/YYYY HH:mm");
        },
        formatLastActionTime(contact) {
            if (!contact.lastActionTime) return "-";
            return this.$moment(contact.lastActionTime).fromNow();
        },
        formatCreatedAt(contact) {
            if (!contact.createdAt) return "-";
            return this.$moment(contact.createdAt).format("DD/MM/YYYY HH:mm");
        },
        formatUpdatedAt(contact) {
            if (!contact.updatedAt) return "-";
            return this.$moment(contact.updatedAt).format("DD/MM/YYYY HH:mm");
        },
        formatFullDateTime(dateTime) {
            if (!dateTime) return "-";
            return this.$moment(dateTime).format("DD/MM/YYYY HH:mm:ss");
        },
        getAnswerStatusText(status) {
            return status === "answered" ? this.$t('chat.contactList.answered') : this.$t('chat.contactList.unanswered');
        },
        getUnreadStatus(contact) {
            return contact.unread ? this.$t('chat.contactList.unreadStatus') : this.$t('chat.contactList.readStatus');
        },
        getVipStatus(contact) {
            return contact.vipCustomer ? this.$t('chat.contactList.vipStatus') : this.$t('chat.contactList.normal');
        },
        getBlockedStatus(contact) {
            return contact.blockedSnapshot ? this.$t('chat.contactList.blocked') : this.$t('chat.contactList.normal');
        },
        getPreferredLangLabel(contact) {
            if (!contact.preferredLang) return "-";
            const language = this.languages.find((lang) => lang.code === contact.preferredLang);
            return language ? language.name : contact.preferredLang;
        },
        getContactPropertyRawValue(contact, propertyId) {
            if (!contact.contactPropertiesSnapshot || !propertyId) return null;
            return contact.contactPropertiesSnapshot[propertyId] || null;
        },
        getBroadcastStatus(contact) {
            return contact.lastBroadcastInfo?.status || "unknown";
        },
        getBroadcastStatusText(contact) {
            if (!contact.lastBroadcastInfo?.status) return "-";

            const statusMap = {
                "enqueued": this.$t('chat.contactList.enqueued'),
                "sent": this.$t('chat.contactList.sent'),
                "delivered": this.$t('chat.contactList.delivered'),
                "read": this.$t('chat.contactList.read'),
                "delete": this.$t('chat.contactList.deleted'),
                "failed": this.$t('chat.contactList.failed')
            };

            return statusMap[contact.lastBroadcastInfo.status] || contact.lastBroadcastInfo.status;
        },
        getBroadcastAnswered(contact) {
            return contact.lastBroadcastInfo?.answered || false;
        },
        getBroadcastAnsweredText(contact) {
            if (contact.lastBroadcastInfo?.answered === undefined) return "-";
            return contact.lastBroadcastInfo.answered ? this.$t('chat.contactList.replied') : this.$t('chat.contactList.notReplied');
        },
        openJsonModal(contact, propertyId) {
            const rawValue = this.getContactPropertyRawValue(contact, propertyId);
            if (!rawValue) return;

            const property = this.contactProperties.find((cp) => cp._id === propertyId);
            const propertyTitle = property?.label || property?.name || this.$t('chat.contactList.jsonProperty');

            try {
                // JSON'ı güzel formatla
                const formattedJson =
                    typeof rawValue === "string"
                        ? JSON.stringify(JSON.parse(rawValue), null, 2)
                        : JSON.stringify(rawValue, null, 2);

                this.jsonModal = {
                    visible: true,
                    title: propertyTitle,
                    content: formattedJson,
                    propertyId: propertyId,
                };
            } catch (error) {
                // JSON parse hatası durumunda raw değeri göster
                this.jsonModal = {
                    visible: true,
                    title: propertyTitle,
                    content: rawValue,
                    propertyId: propertyId,
                };
            }
        },
        closeJsonModal() {
            this.jsonModal = {
                visible: false,
                title: "",
                content: "",
                propertyId: null,
            };
        },
        copyJsonContent() {
            copyText2Clipboard(this.jsonModal.content);
            this.$message.success(this.$t('chat.contactList.jsonCopiedSuccess'));
        },
        highlighter(code) {
            return Prism.highlight(code, Prism.languages.javascript, "javascript");
        },
        async openContact(contactId) {
            let contact = await this.getContactById(contactId);
            if (!contact?.inited)
                contact = await this.fetchContact({
                    contactId,
                    ignoreSource: "ContactList.openContact",
                    viewed: true,
                });

            const windows = this.$store.state.app.windows;
            const windowKeys = Object.keys(windows);
            const lastWindowKey = windowKeys[windowKeys.length - 1];
            const lastWindow = windows[lastWindowKey];

            if (
                lastWindow &&
                lastWindow.type === "grid-chat-window-contact" &&
                lastWindow.payload &&
                lastWindow.payload.contactId === contact._id
            ) {
                return;
            }

            this.addNewWindow({
                type: "grid-chat-window-contact",
                title: contact.fullname || contact.email || contact.phone || this.$t('chat.contactList.unknownContact'),
                autoClose: false,
                multiple: false,
                fullShow: true,
                footer: false,
                payload: {
                    contactId: contact._id,
                },
            });
        },
        getTagStyle(tag) {
            if (!tag.color) {
                return {
                    color: '#6b7785',
                    borderColor: '#d9d9d9'
                };
            }

            // Renk parlaklığını hesapla
            const getLuminance = function(hexColor) {
                // # karakterini kaldır
                const hex = hexColor.replace('#', '');

                // RGB değerlerini al
                const r = parseInt(hex.substr(0, 2), 16);
                const g = parseInt(hex.substr(2, 2), 16);
                const b = parseInt(hex.substr(4, 2), 16);

                // Relative luminance hesapla
                return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
            };

            const luminance = getLuminance(tag.color);

            // Parlak renkler için daha koyu ton kullan (okunabilirlik için)
            // Açık renk ise rengi %30 koyulaştır, koyu renk ise olduğu gibi kullan
            const getDarkerColor = function(hexColor, percent) {
                const hex = hexColor.replace('#', '');
                const r = parseInt(hex.substr(0, 2), 16);
                const g = parseInt(hex.substr(2, 2), 16);
                const b = parseInt(hex.substr(4, 2), 16);

                const darkerR = Math.floor(r * (1 - percent));
                const darkerG = Math.floor(g * (1 - percent));
                const darkerB = Math.floor(b * (1 - percent));

                return '#' +
                    darkerR.toString(16).padStart(2, '0') +
                    darkerG.toString(16).padStart(2, '0') +
                    darkerB.toString(16).padStart(2, '0');
            };

            // Parlak renkler için yazı ve border rengini koyulaştır
            const textColor = luminance > 0.6 ? getDarkerColor(tag.color, 0.4) : tag.color;

            return {
                borderColor: textColor,
                color: textColor
            };
        },
    },
};
</script>

<style lang="scss">
.contact-list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .contact-list-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 0;
        border-bottom: 1px solid #e8e8e8;
        margin-bottom: 16px;
        flex-shrink: 0;

        .contact-count {
            .count-text {
                font-size: 14px;
                color: #6b7785;
                font-weight: 500;
            }
        }

        .list-actions {
            display: flex;
            align-items: center;
            gap: 8px;

            .column-selector {
                position: relative;

                .column-toggle-btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 32px;
                    height: 32px;
                    border: 1px solid #d9d9d9;
                    border-radius: 6px;
                    background: #fff;
                    cursor: pointer;
                    transition: all 0.15s ease;

                    &:hover {
                        border-color: #22272d;
                        background: #f8f9fa;
                    }

                    .material-icons {
                        font-size: 18px;
                        color: #6b7785;
                    }
                }
            }
        }
    }

    .contact-list-content {
        flex: 1;
        min-height: 0;
    }

    /* Eski tablo stillerini kaldırdık; sadece badge ve boş durum stilleri bırakılıyor */
    .platform-badge {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 4px 8px;
        border-radius: 16px;
        font-size: 12px;
        font-weight: 500;

        &.platform-web {
            background: #e3f2fd;
            color: #1976d2;
        }

        &.platform-whatsapp {
            background: #e8f5e8;
            color: #4caf50;
        }

        &.platform-telegram {
            background: #e1f5fe;
            color: #0288d1;
        }

        &.platform-instagram {
            background: #fce4ec;
            color: #e91e63;
        }

        &.platform-supsis {
            color: black;
        }

        &.platform-messenger {
            background: #e3f2fd;
            color: #1565c0;
        }

        &.platform-meta-leads {
            background: #e3f2fd;
            color: #1565c0;
        }

        &.platform-trendyol {
            background: #fff3e0;
            color: #f57c00;
        }

        &.platform-linkedin {
            background: #e3f2fd;
            color: #0d47a1;
        }

        &.platform-email {
            background: #f3e5f5;
            color: #7b1fa2;
        }

        .platform-icon {
            font-size: 16px;

            &.supsis-icon {
                width: 16px;
                height: 16px;
            }
        }

        .platform-text {
            text-transform: capitalize;
        }
    }

    .vip-indicator {
        display: flex;
        align-items: center;
        justify-content: center;

        .material-icons {
            font-size: 20px;
            color: #bfbfbf;
            transition: color 0.2s ease;
        }

        &.vip-active .material-icons {
            color: #ffd700;
        }
    }

    .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 64px 32px;
        color: #6b7785;

        .empty-icon {
            font-size: 48px;
            color: #bfbfbf;
            margin-bottom: 16px;
        }

        .empty-text {
            font-size: 16px;
            font-weight: 500;
        }
    }

    // Yeni kolonlar için stiller
    .answer-status {
        padding: 2px 8px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;

        &.answer-answered {
            background: #e8f5e8;
            color: #4caf50;
        }

        &.answer-unanswered {
            background: #fff3cd;
            color: #856404;
        }
    }

    .unread-status {
        display: flex;
        align-items: center;
        justify-content: center;

        .material-icons {
            font-size: 18px;
            color: #bfbfbf;

            &.unread-active {
                color: #f39c12;
            }
        }

        &.unread-active .material-icons {
            color: #f39c12;
        }
    }

    .departments-container {
        .departments-text {
            font-size: 12px;
            color: #6b7785;
        }
    }

    .connection-time,
    .last-action-time,
    .last-conversation-date,
    .created-at-text,
    .updated-at-text {
        font-size: 12px;
        color: #6b7785;
        cursor: help;
    }

    .os-text,
    .browser-text,
    .country-city-text,
    .ip-address-text,
    .preferred-lang-text {
        font-size: 12px;
        color: #6b7785;
    }

    .visiting-page-text,
    .contact-properties,
    .last-conversation-users {
        font-size: 12px;
        color: #6b7785;
        cursor: help;
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 200px;
    }

    .blocked-status {
        display: flex;
        align-items: center;
        gap: 4px;

        .material-icons {
            font-size: 16px;
            color: #4caf50;
        }

        &.blocked-active .material-icons {
            color: #f44336;
        }

        span {
            font-size: 12px;
        }
    }

    // Etiket stilleri
    .tags-container {
        display: flex;
        flex-wrap: nowrap;
        gap: 6px;
        align-items: center;

        .tag-chip {
            display: inline-flex;
            align-items: center;
            padding: 3px 10px;
            border-radius: 14px;
            font-size: 11px;
            font-weight: 600;
            letter-spacing: 0.2px;
            border: 1.5px solid;
            background: transparent;
            white-space: nowrap;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
            cursor: default;

            &:hover {
                transform: translateY(-1px);
                box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
            }
        }

        .no-tags {
            color: #6b7785;
            font-size: 12px;
            font-style: italic;
        }
    }

    // Contact property value stilleri
    .contact-property-value {
        font-size: 12px;
        color: #22272d;
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 150px;
    }

    // Son sohbet katılımcıları avatar ve isim stilleri
    .conversation-users-container {
        display: flex;
        flex-wrap: nowrap;
        gap: 15px;

        .user-item {
            display: flex;
            align-items: center;
            gap: 6px;

            .user-mini-avatar {
                flex-shrink: 0;

                #avatar-wrapper {
                    width: 24px !important;
                    height: 24px !important;
                    min-width: 24px !important;
                    min-height: 24px !important;
                    gap: 0 !important;

                    #avatar-img,
                    #avatar-placeholder {
                        width: 24px !important;
                        height: 24px !important;
                        min-width: 24px !important;
                        min-height: 24px !important;
                        border-width: 1px !important;
                    }

                    #online-dot,
                    #offline-dot {
                        width: 6px !important;
                        height: 6px !important;
                        bottom: 0px !important;
                        right: 0px !important;
                    }

                    .name-container {
                        display: none;
                    }
                }
            }

            .user-name {
                font-size: 11px;
                color: #22272d;
                font-weight: 500;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 120px;
            }
        }

        .no-users {
            color: #6b7785;
            font-size: 12px;
            font-style: italic;
        }
    }

    // JSON Badge (Platform badge gibi)
    .json-badge {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 4px 8px;
        border-radius: 16px;
        font-size: 12px;
        font-weight: 500;
        background: #f3e8ff;
        color: #7c3aed;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
            background: #e9d5ff;
            color: #6d28d9;
            transform: translateY(-1px);
        }

        .json-icon {
            font-size: 16px;
        }

        .json-text {
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }
    }

    // Broadcast Status Badge
    .broadcast-status {
        display: inline-block;
        padding: 4px 8px;
        border-radius: 12px;
        font-size: 11px;
        font-weight: 500;

        &.broadcast-enqueued {
            background: #fff3cd;
            color: #856404;
        }

        &.broadcast-sent {
            background: #cce5ff;
            color: #004085;
        }

        &.broadcast-delivered {
            background: #d4edda;
            color: #155724;
        }

        &.broadcast-read {
            background: #d1ecf1;
            color: #0c5460;
        }

        &.broadcast-delete {
            background: #f8d7da;
            color: #721c24;
        }

        &.broadcast-failed {
            background: #f8d7da;
            color: #721c24;
        }

        &.broadcast-unknown {
            background: #e2e3e5;
            color: #383d41;
        }
    }

    // Broadcast Answered Status
    .broadcast-answered {
        display: flex;
        align-items: center;
        gap: 4px;

        .material-icons {
            font-size: 16px;
            color: #bfbfbf;
        }

        span {
            font-size: 12px;
            color: #6b7785;
        }

        &.answered-active {
            .material-icons {
                color: #4caf50;
            }

            span {
                color: #4caf50;
                font-weight: 500;
            }
        }
    }
}
</style>

<style lang="scss">
// JSON Modal stilleri (global)
.my-editor {
    background: #f7f7f7;
    color: #ccc;
    font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
    font-size: 14px;
    line-height: 1.5;
    padding: 12px;
    max-height: 400px;
    overflow: auto;
    border: 1px solid #e1e3e6;
    border-radius: 6px;
    margin-bottom: 16px;
}
</style>
